module.exports = ".error {\n  color: crimson; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/login/login.component.scss
// module id = ./src/app/authentication/login/login.component.scss
// module chunks = main